import React,{useEffect,useState,useRef} from "react";
import IconButton from "@mui/material/IconButton";
import { Box, Typography, makeStyles, Grid, LinearProgress } from "@mui/material";
import StarRatingoComponent from "../../atom/Buttons/StarRating";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import {
  IMAGE_URL,
  getSourcePath,
  getText,
  onToast,
} from "../../../core/Constant";
import _ from "lodash";
import { List, ListItem } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { useSelector } from "react-redux";
import WaterMark from '@uiw/react-watermark';
import UserRepository from '../../../core/repository/UserRepository';
import { useWatermarkProtection } from "../../../hook/useWatermarkProtection";

const QuizAssesmentCard = ({
  data,
  index,
}) => {
  const [answer, setAnswer] = useState([]);
  const [correct, setCorrect] = useState([]);
  const [isFlag, setFlag]=useState(false);

  const [show, setShow] = useState(false)
  const [userInfo, setUserInfo] = useState({ name: '', contact: '', email: '' });
  const [watermarkKey, setWatermarkKey] = useState(0);

   const hasTriggeredRef = useRef(false);
     
       const sendTamperingAlert = async () => {
         try {
           const res = await UserRepository.temperingAlertMail();
         } catch (e) {
           console.error("Tampering alert error:", e);
         }
       };
   
       useWatermarkProtection({
       onTamper: () => {
         if (!hasTriggeredRef.current) {
         hasTriggeredRef.current = true;
         sendTamperingAlert(); 
       }
       setWatermarkKey(prev => prev + 1);
       }
     });

  // Fetch user details
  useEffect(() => {
    const getUser = async () => {
      const user = await UserRepository.getUserDetail();
      setUserInfo({
        name: `${user?.data?.first_name || ""} ${user?.data?.last_name || ""}`.trim(),
        contact: user?.data?.phone_number || '',
        email: user?.data?.email || '',
      });
    };
    getUser();
  }, []);

  const loadingAction = useSelector(state => state.common.get('loadingAction'));

  useEffect(() => {
    if (loadingAction?.action?.type == 'GET_ASSESSMENT_QUESTION_N_REASON') {
       if(loadingAction?.loading){
        setShow(loadingAction?.loading)
       }else{
        _.delay(()=>{
          setShow(loadingAction?.loading)
        },2000)
       }
      
    }
  }, [loadingAction])

  useEffect(() => {
    const anw = _.get(data, "quiz_results[0].answer", []);
    if (anw.length > 0) {
      setAnswer(anw);
    }
    setFlag(_.get(data,'quiz_results[0].is_flag',false));
    const anwAll = _.get(data, "answers", []);
    const isCorrect = _.filter(anwAll, (item) => item.is_correct == 1);
    setCorrect(isCorrect);
  }, [data]);

  const handleChange = (event) => {
    const text = getText(event);
    setAnswer([text]);
  };

  const handlechangeForm = (event) => {
    const text = getText(event);
    const isChecked = _.findIndex(answer, (i) => i == text) > -1;
    if (!isChecked) {
      setAnswer([...answer, text]);
    } else {
      const anw = _.filter(answer, (i) => i !== text);
      setAnswer(anw);
    }
  };

  return (
    <>
      {/* Watermark overlay */}
      <WaterMark key={watermarkKey} className="watermark-protection"
        content={[
                  userInfo.name,
                  userInfo.contact,
                  userInfo.email,
                ]}
        gap={[10, 10]}
        fontSize={12}
        zIndex={10}
        rotate={-20}
        offsetLeft={50}
        fontColor="rgba(0, 0, 0, 0.25)"
      >
      <Grid
        sx={{ position: 'relative', zIndex: 1 }}
            container
            justifyContent={"space-between"}
            alignItems={"flex-start"}
            style={{marginBottom:2}}
          >
            <Grid item>
              <Box sx={{ display: "flex", gap: 1 }}>
              {!show &&<Box
                    
                    sx={{
                      width: "50px",
                      border: "solid",
                      borderWidth: 1,
                      textTransform: "capitalize",
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      borderRadius: 2,
                      borderColor: isFlag ? 'transparent' : 'black',
                      backgroundColor: isFlag ? "#FFB200 !important" : '#ffffff'
                    }}
                  >

                    {isFlag ? <FlagIcon sx={{ color: "#ffffff" }} fontSize="small" /> : <FlagOutlinedIcon color="secondary" fontSize="small" />}

                  </Box>}
                  
              </Box>
            </Grid>
            
          </Grid>
      <>
      {show ? <Grid item>
                      <Grid container>
                        <Grid item sx={{ width: '100%', height: 20 }}>
                          <Box >
                            <LinearProgress />
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid> : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: 1,
            height: "auto",
            minHeight: 300,
            justifyContent: "flex-start",
          }}
        >
          
          <Box sx={{ width: 1 }}>
            <div
              dangerouslySetInnerHTML={{
                __html: `${index + 1}. ${data?.question}`,
              }}
            />
          </Box>

            {data?.images && data.images.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                    my: 2.5,
                    width: "100%",
                  }}
                >
                  {data.images.map((img, idx) => (
                    <Box
                      key={img.id || idx}
                      component="img"
                      sx={{
                        width: "100%",
                        maxWidth: data.images.length === 1 ? 400 : 260,
                        maxHeight: 280,
                        objectFit: "contain",
                        borderRadius: 1.5,
                        boxShadow: 1,
                        backgroundColor: "#f5f5f5",
                        p: 0.5,
                      }}
                      src={getSourcePath(img.image_path)}
                      alt={`question-img-${idx}`}
                    />
                  ))}
                </Box>
              )}

              <Box sx={{ width: 1 }}>
            {data?.type == 2 ? (
              <FormControl
                variant="outlined"
                margin="normal"
                component="fieldset"
                defaultValue={[]}
                onChange={handlechangeForm}
                style={{ marginTop: '10px' }}
              >
                <FormGroup
                  style={{
                    display: "grid",
                    marginTop: 10,
                    marginRight: 5,
                    gap: 5,
                    gridTemplateColumns: "repeat(2, 1fr)",
                  }}
                >
                  {data?.answers?.map((item) => {
                    const isChecked =
                      _.findIndex(answer, (i) => i == item.id) > -1;

                    return (
                      <Box key={item.id} className="quiz-box">
                        <FormControlLabel
                          value={item.id}
                          control={<>
                            <Checkbox
                              color={item?.is_correct ? "success" : "error"}
                              checked={isChecked}
                            />
                          </>}
                          label={item.answer}
                        />
                      </Box>
                    );
                  })}
                </FormGroup>
              </FormControl>
            ) : (
              <FormControl
                style={{ marginTop: '10px' }}
              >
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  style={{
                    display: "grid",
                    gap: 5,
                    gridTemplateColumns: "repeat(2, 1fr)",
                  }}
                  value={answer}
                  onChange={handleChange}
                >
                  {data?.answers?.map((item) => {
                    const isChecked = answer[0] == item.id;
                    // Map item.id to letter: 1->A, 2->B, ...
                    const labelLetter = String.fromCharCode(64 + Number(item.id));
                    return (
                      <Box key={item.id} className="quiz-box">
                        <FormControlLabel
                          value={item.id}
                          control={
                            <Radio
                              disabled={!isChecked}
                              color={item?.is_correct == 1 ? "success" : "error"}
                              checked={isChecked}
                            />
                          }
                          label={`${labelLetter}. ${item.answer}`}
                        />
                      </Box>
                    );
                  })}
                </RadioGroup>
              </FormControl>
            )}
          </Box>
          </Box>
        )}
      {!show &&  <p className="attempt-answer">
          {`Correct answer ${correct.length > 1 ? "are" : "is"}`}
          <List>
            {correct.map((item, index) => {
              const labelLetter = String.fromCharCode(64 + Number(item.id));
              return (
                <ListItem key={`anw${index}`}>
                  <span style={{ color: "#28b882", fontWeight: 700 }}>
                    {`${labelLetter}. ${item?.answer}`}
                  </span>
                </ListItem>
              );
            })}
          </List>
        </p>}
       {!show && <p
          style={{ fontWeight: 800, color: "black", fontSize: 16 }}
          className="attempt-reason"
        >
          Reason:
          {data?.reason !== null ? (
            <div
              dangerouslySetInnerHTML={{
                __html: data?.reason,
              }}
            />
          ) : (
            <span> Reason not found</span>
          )}
        </p>}
      </>
      </WaterMark>
    </>
  );
};

export default QuizAssesmentCard;
